import { useTranslation } from "react-i18next";
import { useDeviceUsersByCustomerId } from "./data/Assignment/useDeviceUsersByCustomerId";
import { useEffect } from "react";

import clsx from "clsx";
import { Dropdown, DropdownProps } from "primereact/dropdown";
import CircularProgress from "@mui/material/CircularProgress";
import { MessageToast, ToastMode } from "./shared/MessageToast";
import { ValidationMessage } from "./shared/ValidationMessage";

interface Props {
  customerId?: number;
  assetId?: number;
  onAssignedUserChange: (assignedUserId: string) => void;
  selectedDeviceUserId?: string | null;
  invalid?: boolean;
  invalidMessage?: string;
  onUsernameChange?: (username: string) => void;
}

export function UserDropdown(props: Props & DropdownProps) {
  const { t } = useTranslation();
  const {
    customerId,
    assetId,
    selectedDeviceUserId,
    onAssignedUserChange,
    invalid,
    invalidMessage,
    onUsernameChange,
    ...rest
  } = props;

  const users = useDeviceUsersByCustomerId(customerId, assetId);

  function handleChange(e: any) {
    onAssignedUserChange(e.value);
  }

  useEffect(() => {
    if (users.data && selectedDeviceUserId && onUsernameChange) {
      const selectedUsername = users.data.find((user) => user.id === selectedDeviceUserId)?.userName;
      selectedUsername && onUsernameChange(selectedUsername);
    }
  }, [onUsernameChange, selectedDeviceUserId, users.data]);

  if (users.isLoading) {
    return <CircularProgress size={24} />;
  } else if (users.isError) {
    return <MessageToast text={t("common.dataFetchError", { val: "$t(common.users)" })} mode={ToastMode.Error} show />;
  } else
    return (
      <div className="d-flex justify-content-start">
        <div className="d-flex flex-column">
          <Dropdown
            className={clsx({ "p-invalid": invalid })}
            disabled={!customerId}
            value={selectedDeviceUserId}
            optionValue="id"
            options={users.data}
            onChange={handleChange}
            optionLabel="email"
            filter
            filterBy="email"
            placeholder={t("common.selectUser")}
            {...rest}
          />

          {invalid && invalidMessage && (
            <ValidationMessage invalidMessage={invalidMessage} validationType="error" showIcon />
          )}
        </div>
      </div>
    );
}
